export default "__VITE_ASSET__BSCxeE3O__"